import { render, staticRenderFns } from "./PagePaymentLMSG.vue?vue&type=template&id=658de97b&"
import script from "./PagePaymentLMSG.vue?vue&type=script&lang=js&"
export * from "./PagePaymentLMSG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658de97b')) {
      api.createRecord('658de97b', component.options)
    } else {
      api.reload('658de97b', component.options)
    }
    module.hot.accept("./PagePaymentLMSG.vue?vue&type=template&id=658de97b&", function () {
      api.rerender('658de97b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/PagePaymentLMSG.vue"
export default component.exports